import React from 'react';
import { Paper, Button } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import { drawerBottomButton, drawerBottom } from './style';

export default function Module({ onClick = () => {} }) {
  const { t2 } = useTranslation('EditCourse');

  return (
    <Paper elevation={3} style={drawerBottom}>
      <Button variant="contained" style={drawerBottomButton} onClick={onClick}>
        {t2('AddModule')}
      </Button>
    </Paper>
  );
}
